var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDialogueImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 196,
    viewBox: "0 0 400 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1988_19423)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 196,
    rx: 8,
    fill: "#01A3D2",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: -101,
    y: 20,
    width: 602,
    height: 602,
    fill: "url(#paint0_radial_1988_19423)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.653 105.546L201.72 78.1494L160.539 105.634L201.632 132.944L242.653 105.546Z",
    fill: "#008EB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.296 90.0205H166.918V148.998H238.398V102.333L221.296 90.0205Z",
    fill: "#A2D5EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M221.385 102.245L238.399 115.628V102.245",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202 97C193.472 96.9902 186.259 103.316 185.146 111.782C184.034 120.248 189.366 128.227 197.607 130.426L196.354 125.433C191.051 122.806 188.253 116.869 189.6 111.102C190.947 105.334 196.084 101.254 202 101.254C207.916 101.254 213.053 105.334 214.4 111.102C215.747 116.869 212.949 122.806 207.646 125.433L206.393 130.426C214.634 128.227 219.966 120.248 218.854 111.782C217.741 103.316 210.528 96.9902 202 97ZM212.611 113.999C212.611 109.003 209.134 104.681 204.258 103.618C199.382 102.554 194.425 105.036 192.349 109.58C190.273 114.124 191.64 119.501 195.632 122.499C196.381 123.078 197.21 123.543 198.094 123.881L198.71 126.303L199.877 130.872C201.287 131.035 202.712 131.035 204.122 130.872L205.247 126.303L205.862 123.881C206.761 123.547 207.605 123.082 208.367 122.499C211.039 120.493 212.611 117.344 212.611 113.999ZM202.001 105.5C197.313 105.5 193.512 109.306 193.512 114C193.512 116.254 194.406 118.416 195.998 120.01C197.59 121.604 199.75 122.5 202.001 122.5C206.69 122.5 210.491 118.694 210.491 114C210.491 109.306 206.69 105.5 202.001 105.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.93 110.64C193.374 106.301 197.43 103.375 201.997 103.375C206.565 103.375 210.62 106.301 212.065 110.64C213.509 114.979 212.019 119.756 208.365 122.5C207.616 123.079 206.786 123.544 205.903 123.881C203.394 124.875 200.601 124.875 198.092 123.881C197.208 123.544 196.379 123.079 195.63 122.5C191.976 119.756 190.486 114.979 191.93 110.64ZM193.508 114C193.508 118.694 197.309 122.5 201.998 122.5C204.25 122.5 206.409 121.604 208.001 120.01C209.593 118.416 210.488 116.254 210.488 114C210.488 109.306 206.687 105.5 201.998 105.5C197.309 105.5 193.508 109.306 193.508 114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.244 122.5L205.905 123.881L205.289 126.304L204.165 130.873L204.122 131H199.877L199.835 130.873L198.71 126.304L198.094 123.881L197.755 122.5H206.244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202,
    cy: 114,
    rx: 4.24481,
    ry: 4.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.363 160.327L201.631 132.944L160.538 105.635L160.363 105.723V160.327ZM243.001 105.723L242.652 105.547L201.631 132.944L243.001 160.327V105.723Z",
    fill: "#01A3D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.631 132.944L160.363 160.327V160.415H243.001V160.327L201.631 132.944Z",
    fill: "#008EB7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.385 90.0205V102.245L238.399 102.333L221.385 90.0205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.274 96.6614V90H114.054V96.6614H107.393V98.8818H114.054V105.543H116.274V98.8818H122.936V96.6614H116.274Z",
    fill: "#1695CA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M122.063 139.03C121.841 139.03 121.619 139.03 121.397 138.808L117.844 135.033C117.622 134.811 117.622 134.145 117.844 133.923C118.066 133.7 118.732 133.7 118.954 133.923L122.063 137.031L129.613 127.927C129.835 127.705 130.279 127.483 130.723 127.927C130.945 128.149 131.167 128.593 130.945 129.038L122.951 138.808C122.507 138.808 122.285 139.03 122.063 139.03Z",
    fill: "#1695CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.661 36H192.882V40.4409H190.661V36ZM190.661 47.1023H192.882V51.5432H190.661V47.1023ZM184 42.6614H188.441V44.8818H184V42.6614ZM195.102 42.6614H199.543V44.8818H195.102V42.6614Z",
    fill: "#1695CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.661 71.3228H146.882V77.9841H144.661V71.3228ZM144.661 58H146.882V64.6614H144.661V58ZM138 66.8818H142.441V69.1023H138V66.8818ZM149.102 66.8818H153.321V69.1023H149.102V66.8818Z",
    fill: "#1695CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.62 129.243H282.841V133.684H280.62V129.243ZM280.62 140.345H282.841V144.786H280.62V140.345ZM273.959 135.905H278.4V138.125H273.959V135.905ZM285.061 135.905H289.502V138.125H285.061V135.905Z",
    fill: "#1695CA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M256.844 125.928C256.622 125.928 256.622 125.928 256.622 125.706L254.624 123.708C254.402 123.486 254.402 123.264 254.624 123.042C254.846 122.82 255.068 122.82 255.29 123.042L256.844 124.818L260.841 119.933C261.063 119.711 261.285 119.711 261.507 119.933C261.729 120.155 261.729 120.377 261.507 120.599L257.288 125.706C257.066 125.928 256.844 125.928 256.844 125.928Z",
    fill: "#1695CA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M282.824 78.1887H276.163V71.5273H273.943V78.1887H267.281V80.4092H273.943V87.0706H276.163V80.4092H282.824V78.1887Z",
    fill: "#1695CA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M236.418 66.8639C236.196 66.8639 235.974 66.8639 235.974 66.6419L232.643 63.3112C232.421 63.0891 232.421 62.6451 232.643 62.423C232.865 62.201 233.309 62.201 233.531 62.423L236.196 65.3096L242.857 57.3159C243.079 57.0939 243.523 57.0939 243.745 57.3159C243.967 57.538 244.189 57.9821 243.745 58.2041L236.64 66.8639C236.862 66.8639 236.64 66.8639 236.418 66.8639Z",
    fill: "#1695CA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1988_19423",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(200 321) rotate(90) scale(301)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35BDE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#35BDE4",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755208,
    stopColor: "#35BDE4",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#35BEE4",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35BDE4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1988_19423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 196,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialogueImage);
export default __webpack_public_path__ + "static/media/dialogue-image.7601413fd60851039fc40062eed45f22.svg";
export { ForwardRef as ReactComponent };